import React, { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { useDispatch } from "react-redux";
import {
  PaymentSettingAdminFetch,
  PaymentSettingAdminUpdate,
  updateWithdrawSettingAdmin,
  withdrawPaymentSettingAdminFetch,
} from "../../../Redux/Actions/AdminManagerUserAction";
import { setAlert } from "../../../Redux/Actions/AlertActions";
import AmountLimitModel from "./AmountLimitModel";

const Setting = () => {
  const dispatch = useDispatch();
  const [payment, setPayment] = useState({
    payment: "0",
    transfer: "0",
  });
  const [amountLimit, setAmountLimit] = useState({
    amount: "",
  });
  const [withdrawalAmount, setWithdrawalAmount] = useState({
    amount: "0",
  });
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setType("");
  };
  const [type, setType] = useState("");
  const [loader, setLoader] = useState({
    fetch: true,
    save: false,
    withdrawal: true,
    update: false,
  });
  const handleChangeWithdrawal = (e) => {
    const { name, value } = e.target;
    setWithdrawalAmount({ ...withdrawalAmount, [name]: value });
  };
  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    setPayment({ ...payment, [name]: checked ? "1" : "0" });

    if (name === "payment") {
      setLoader({
        ...loader,
        save: true,
      });
      setType("payment");
      let data = {
        status: checked ? "1" : "0",
        type: "payment",
      };

      dispatch(
        PaymentSettingAdminUpdate(
          "change-setting",
          data,
          loader,
          setLoader,
          false,
          payment,
          setPayment
        )
      );
    }
    if (name === "transfer" && checked === true) {
      setType("transfer");
      setShow(true);
    }
    if (name === "transfer" && checked === false) {
      setLoader({
        ...loader,
        save: true,
      });
      setType("transfer");
      let data = {
        status: "0",
        type: "transfer",
        amount_limit: "0",
      };
      dispatch(
        PaymentSettingAdminUpdate(
          "change-setting",
          data,
          loader,
          setLoader,
          false,
          payment,
          setPayment
        )
      );
    }
  };
  const handleTransfer = (type) => {
    setType(type);
    setShow(true);
  };
  const handleSubmit = () => {
    setLoader({
      ...loader,
      save: true,
    });
    if (type === "transfer") {
      if (amountLimit.amount === "") {
        setLoader({
          ...loader,
          save: false,
        });
        dispatch(setAlert("Please enter amount limit", "danger"));
        return;
      }
      let data = {
        status: payment.transfer,
        type: "transfer",
        amount_limit: amountLimit.amount,
      };
      dispatch(
        PaymentSettingAdminUpdate(
          "change-setting",
          data,
          loader,
          setLoader,
          handleClose,
          payment,
          setPayment
        )
      );
    } else {
      let data = {
        status: payment.payment,
        type: "payment",
      };
      dispatch(
        PaymentSettingAdminUpdate(
          "change-setting",
          data,
          loader,
          setLoader,
          false,
          payment,
          setPayment
        )
      );
    }
  };
  const handleUpdateWithdraw=()=>{
    setLoader({
      ...loader,
      update: true,
    })
    let data={
        amount: withdrawalAmount.amount,
    }
    dispatch(updateWithdrawSettingAdmin("update-withdrawl-limit", data, loader, setLoader))
  }
  const fetchData = () => {
    dispatch(
      PaymentSettingAdminFetch("get-setting", setPayment, loader, setLoader)
    );
  };
    const fetchWithdrawalData = () => {
        dispatch(withdrawPaymentSettingAdminFetch("get-withdrawl-limit", setWithdrawalAmount, loader, setLoader));
    }
  useEffect(() => {
    fetchData();
    fetchWithdrawalData()
  }, []);
  return (
    <>
      <div className="account-block mb-3 mb-lg-5 ">
        <h6> Settings</h6>
        <div className="block-white mt-3">
          <div className="notification-cardN">
            {loader.fetch ? (
              <div className="d-flex align-items-center justify-content-center">
                <FaSpinner className="spin" style={{ fontSize: "22px" }} />
              </div>
            ) : (
              <div className="notification-card-single mt-0">
                <div className="notification-card-txt">
                  <h6 style={{ marginBottom: "2px" }}>
                    Payment accept setting
                  </h6>
                  <p>Enable to accept payment request</p>
                </div>
                <span className="custom-switch">
                  <input
                    type="checkbox"
                    checked={payment.payment === "1"}
                    name="payment"
                    onChange={handleChange}
                  />
                  <span className="checkMark">
                    {" "}
                    {loader.save && type === "payment" && (
                      <FaSpinner
                        className="spin"
                        style={{ fontSize: "14px" }}
                      />
                    )}
                  </span>
                  {/* {loader.save && <FaSpinner className='spin' style={{ fontSize: "14px" }} />} */}
                </span>
              </div>
            )}
          </div>
        </div>
        {/* <div className="btnGroup mt-3"><button type="button" className="theme-btn" onClick={handleSubmit}>Save {loader.save ? <FaSpinner className="spin ms-1" /> : null}</button></div> */}
        <div className="block-white mt-3">
          <div className="notification-cardN">
            {loader.fetch ? (
              <div className="d-flex align-items-center justify-content-center">
                <FaSpinner className="spin" style={{ fontSize: "22px" }} />
              </div>
            ) : (
              <div className="notification-card-single mt-0">
                <div className="notification-card-txt">
                  <h6 style={{ marginBottom: "2px" }}>
                    Transfer amount setting
                  </h6>
                  <p>Enable to Transfer amount</p>
                </div>
                <span className="custom-switch">
                  <input
                    type="checkbox"
                    checked={payment.transfer === "1"}
                    name="transfer"
                    onChange={handleChange}
                  />
                  <span className="checkMark">
                    {loader.save && type === "transfer" && (
                      <FaSpinner
                        className="spin"
                        style={{ fontSize: "14px" }}
                      />
                    )}
                  </span>
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="block-white mt-3 pt-2">
          <div className="notification-cardN">
            {loader.withdrawal ? (
              <div className="d-flex align-items-center justify-content-center">
                <FaSpinner className="spin" style={{ fontSize: "22px" }} />
              </div>
            ):
            <div className="creator_new_task h-100 mb-0 p-0">
           <div className="account-block phone-emails mb-0 p-0" style={{background:"unset"}}>
                 <div className="submission_wrap submission_bg px-1">
              <h6 style={{fontSize:"15px"}} className="form-label">Approval Limit</h6>
              <input
                type="number"
                className="form-control border-0 "
                placeholder="Enter amount"
                name="amount"
                value={withdrawalAmount.amount}
                onChange={handleChangeWithdrawal}
                onKeyDown={(e) => {
                  if (
                    !/^\d$/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight"
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
           </div>
            </div>
}
          </div>
            <div className="btnGroup"><button type="button" className="theme-btn" onClick={handleUpdateWithdraw} disabled={!withdrawalAmount.amount||loader.update} style={{ cursor: !withdrawalAmount.amount|| loader.update ? "not-allowed" : "pointer", background: !withdrawalAmount.amount || loader.update? "#afafaf" : "" }}>{loader.update ? <>Updating<FaSpinner className='spin ms-1' style={{ fontSize: "13px" }} /> </> : "Update"}</button></div>
        </div>
      
      </div>
      <AmountLimitModel
        show={show}
        handleClose={handleClose}
        amountLimit={amountLimit}
        setAmountLimit={setAmountLimit}
        loader={loader}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default Setting;
